import React from "react";
import LockIcon from "@mui/icons-material/Lock";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ProcessGuideDialog from "../../../library/Dialog/ProcessGuideDialog";

const guideSteps = [
  {
    label: "Check income",
    icon: LockIcon,
    title: "Start in Foreign Income",
    guidelines: [
      {
        label: "Check current year income",
        text: "Current year amounts come from linked schedules. Check the amounts and select an Income Type for each row.",
      },
      {
        label: "Add prior year income, if any",
        text: "Click the + icon in Prior Year Unremitted Foreign Income, or use Upload Excel. Enter the Income Type, YA Earned (Year of Assessment), income, expenses and foreign tax.",
      },
      {
        label: "Choose a country, if known",
        text: "You can leave Country blank, including in Excel uploads. These rows are grouped under Unspecified.",
      },
      {
        label: "Lock each completed row",
        text: "Click the lock icon under Actions. Only locked rows appear in Unremitted Income Tracker. Prior year rows need both Income Type and YA Earned before locking.",
      },
    ],
    reminder:
      "To edit a locked row, unlock it first. This removes its tracker entry. Lock it again and re-enter any amounts received or used.",
  },
  {
    label: "Enter amounts",
    icon: TrendingUpIcon,
    title: "Open Unremitted Income Tracker",
    guidelines: [
      {
        label: "Received in SG (B)",
        text: "Enter the income received in Singapore. Leave it at 0 if nothing was received.",
      },
      {
        label: "Used not Received (C)",
        text: "Enter income used overseas without being received in Singapore. Leave it at 0 if none was used.",
      },
      {
        label: "Check the income left",
        text: "Unremitted c/f (D) shows the income still available. The tracker calculates expenses and foreign tax for you.",
      },
      {
        label: "Find or sort rows",
        text: "Use the country, year or search filters to find rows. Click YA Earned in the tracker or prior year table to switch between oldest and newest first. Rows only sort when you click.",
      },
    ],
    reminder:
      "Received and used amounts together cannot exceed the available income. If they do, the tracker adjusts them automatically.",
  },
  {
    label: "Review and save",
    icon: AssessmentIcon,
    title: "Check the summary, then save",
    guidelines: [
      {
        label: "Check the summary below the tracker",
        text: "Only income received in Singapore appears here. Check the totals for each income type and country.",
      },
      {
        label: "Select Foreign Tax Credit (FTC) claims",
        text: "Click the icon under FTC Claim for any group you want to claim. It is enabled only when both net remitted income and the foreign tax allocated to it are above 0.",
      },
      {
        label: "Save your work",
        text: "Click Save at the top of the page. The PDF follows the same row order as the tracker.",
      },
    ],
    reminder:
      "Locking a row adds it to the tracker. Click Save to keep your changes.",
  },
];

const ForeignIncomeGuideline = ({ open, onClose }) => (
  <ProcessGuideDialog
    open={open}
    onClose={onClose}
    title='Foreign Income Tracker guide'
    steps={guideSteps}
    tabsAriaLabel='Foreign income tracking stages'
  />
);

export default ForeignIncomeGuideline;
